import styled from 'styled-components';
import { ReactComponent as MoonSvg } from 'Images/moon.svg';
import { ReactComponent as SunSvg } from 'Images/sun.svg';

export const Wrapper = styled.div`
  padding-top: 5px;
  position: relative;
  width: 44px;
  height: 40px;
`;
Wrapper.displayName = 'Wrapper';

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 30px;
  width: 36px;
`;
IconWrapper.displayName = 'IconWrapper';

export const MoonIcon = styled(MoonSvg)`
  width: 18px;
  height: 18px;
  & > g {
    fill: ${({ theme }) => theme.icons.actionBar.color};
  }
`;
MoonIcon.displayName = 'MoonIcon';

export const SunIcon = styled(SunSvg)`
  width: 20px;
  height: 20px;
  & > g {
    fill: ${({ theme }) => theme.icons.actionBar.color};
    opacity: 1;
  }
`;
SunIcon.displayName = 'SunIcon';
